import React from 'react'
import { DefaultElement } from 'slate-react'

import * as elements from './elements'

export function renderElement (props) {
  switch (props.element.type) {
    case 'paragraph':
      return (
        <elements.Paragraph {...props} />
      )

    case 'heading-two':
      return (
        <elements.Heading {...props} />
      )

    case 'block-quote':
      return (
        <elements.BlockQuote {...props} />
      )

    case 'ordered-list':
      return (
        <elements.OrderedList {...props} />
      )

    case 'unordered-list':
      return (
        <elements.UnorderedList {...props} />
      )

    case 'list-item':
      return (
        <elements.ListItem {...props} />
      )

    case 'checkbox':
      return (
        <elements.Checkbox {...props} />
      )

    case 'checkbox-list-item':
      return (
        <elements.CheckboxListItem {...props} />
      )

    default:
      return (
        <DefaultElement {...props} />
      )
  }
}
